import { WidgetDefinition } from './types';
import { validateWebWidget } from './WebWidget/WebWidgetValidators';
import { validateMobileWidget } from './MobileWidget/MobileWidgetValidators';
import { TFunction } from 'i18next';

export type ValidationErrors = {
  [section: string]: {
    [field: string]: string;
  };
};


export const validateWidget = ( widgetConfig: WidgetDefinition, device: 'web' | 'mobile', t: TFunction ): ValidationErrors | null => {
   const deviceValidateWidget = {
      web: validateWebWidget,
      mobile: validateMobileWidget
    };
    return deviceValidateWidget[device]( widgetConfig, t );
};
